import React from "react";

const ResponsiveAccountTable = ({
  columns,
  rows,
  onOpen,
  actionLabel,
  actionIcon = "fa-arrow-up-right-from-square",
  emptyLabel,
  emptyHint,
  loading = false,
  tableClassName = ""
}) => (
  <div className="account-table-scroll" data-testid="responsive-account-table">
    <table className={`account-table ${tableClassName}`.trim()}>
      <colgroup>
        {columns.map((column) => (
          <col key={column.key} style={column.width ? { width: column.width } : undefined} />
        ))}
        <col className="account-table-action-column" />
      </colgroup>
      <thead>
        <tr>
          {columns.map((column) => (
            <th key={column.key} scope="col" className={column.className}>{column.label}</th>
          ))}
          <th scope="col" className="account-table-actions">{actionLabel}</th>
        </tr>
      </thead>
      <tbody>
        {loading ? (
          Array.from({ length: 6 }, (_, index) => (
            <tr key={`loading-${index}`} className="account-table-skeleton">
              <td colSpan={columns.length + 1}><span /></td>
            </tr>
          ))
        ) : rows.length === 0 ? (
          <tr>
            <td colSpan={columns.length + 1} className="account-empty-cell">
              <div className="account-empty-state">
                <span><i className="fa-regular fa-folder-open" aria-hidden="true" /></span>
                <strong>{emptyLabel}</strong>
                {emptyHint && <small>{emptyHint}</small>}
              </div>
            </td>
          </tr>
        ) : (
          rows.map((row) => (
            <tr key={row._id || row.id}>
              {columns.map((column) => (
                <td key={column.key} data-label={column.label} className={column.className}>
                  {column.render ? column.render(row) : row[column.key] ?? "—"}
                </td>
              ))}
              <td className="account-table-actions">
                <button
                  type="button"
                  className="account-row-action"
                  onClick={() => onOpen(row)}
                  aria-label={actionLabel}
                >
                  <span>{actionLabel}</span>
                  <i className={`fa-solid ${actionIcon}`} aria-hidden="true" />
                </button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
);

export default ResponsiveAccountTable;
